import React from 'react';
import { Lock } from 'lucide-react';
import { InfoPanel } from '@otcmarketsgroup/otcm-ui-lib';

const PrivateInformation = () => {
    return <InfoPanel title='Private Information' icon={<Lock size='20px' color='var(--otc-green)' />}>
        This icon denotes that the information is private and is not publicly displayed.
    </InfoPanel>;
};

export default PrivateInformation;
